import { render, staticRenderFns } from "./WhatsNew.vue?vue&type=template&id=696e1512&"
import script from "./WhatsNew.vue?vue&type=script&lang=js&"
export * from "./WhatsNew.vue?vue&type=script&lang=js&"
import style0 from "./WhatsNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports